class InputNumberManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.elements = []
    }
    run() {
        document.querySelectorAll('[data-input-number]').forEach((el) => {
            (new InputNumber(el, this)).run()
        })
    }
}

class InputNumber {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
        this.input = el.querySelector('input')
    }
    run() {
        this.el.querySelectorAll('[data-input-number-action]').forEach((elAction) => this.initAction(elAction))
    }
    initAction(elAction) {
        elAction.addEventListener('click', (evt) => {
            evt.preventDefault()
            this.changeInput(parseInt(elAction.dataset.inputNumberAction))
        })
    }
    changeInput(value) {
        if (!this.input) {
            return
        }

        const oldValue = parseInt(this.input.value)
        const newValue = parseInt(this.input.value) + value || 1
        this.input.value = newValue

        this.triggerChanger(oldValue, newValue)
    }
    triggerChanger(oldValue, newValue) {
        if (oldValue === newValue) {
            return
        }
        const event = new Event('change')
        this.input.dispatchEvent(event)
    }
}

export default InputNumberManager